module.exports = __webpack_public_path__ + "assets/img/paypal.202343d0.svg";